import { combineReducers } from 'redux'
import langData from '../reducers/langData'
import activeLang from '../reducers/activeLang'
import mapLoaded from '../reducers/mapLoaded'
import allReferencesData from '../reducers/allReferencesData'
import allProjectsArchiveData from '../reducers/allProjectsArchiveData'
import allReferencesFilters from '../reducers/allReferencesFilters'
import contactCategory from '../reducers/contactCategory'
import modalData from '../reducers/modalData'

const combinedReducers = combineReducers({
    langData,
    activeLang,
    mapLoaded,
    allReferencesData,
    allProjectsArchiveData,
    allReferencesFilters,
    contactCategory,
    modalData
})

export default combinedReducers



// WEBPACK FOOTER //
// ./src/scripts/reducers/index.js